import { render, staticRenderFns } from "./NotiListForCustView.vue?vue&type=template&id=3e5a7891"
import script from "./NotiListForCustView.vue?vue&type=script&lang=js"
export * from "./NotiListForCustView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports